// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__pQSly","row":"styles_row__2s-6V"};